import 'regenerator-runtime/runtime';
import axios from 'axios';

const DEV_MODE = false;
const API_BASE_URL = DEV_MODE ? 'http://api.test' : 'https://api.baremetrics.com';
const SESSION_OVERLAP_SECONDS = 5 * 60;

export default class BareTracking {
  constructor(sessionOverlapSeconds = SESSION_OVERLAP_SECONDS, apiBaseUrl = API_BASE_URL) {
    this.sessionOverlapSeconds = sessionOverlapSeconds;
    this.apiBaseUrl = apiBaseUrl;
  }

  configure(accessTokenId, customerOid) {
    this.accessTokenId = accessTokenId;
    this.customerOid = customerOid;
    this.configured = true;
    this.setupEventListeners();
  }

  async track(eventName, properties = {}) {
    DEV_MODE && console.log(`track(${eventName}) -> isNewSession() => ${this.isNewSession()}`)

    // Ensure to track session events just once per session
    if (eventName === 'session' && !this.isNewSession()) {
      return;
    }

    // Exit if no credentials have been configured
    if (!this.configured) {
      console.warn(`[barejs] Missing configuration, set credentials using: ${window['baretracking-method']}('configure', 'access_token_id', 'customer_oid')`);
      return;
    }

    try {
      DEV_MODE && console.log(`Tracking ${eventName} event`);

      // Post event to Baremetrics
      const postData = {
        access_token_id: this.accessTokenId,
        customer_oid: this.customerOid,
        event_name: eventName,
        properties
      };

      await axios.post(
        `${this.apiBaseUrl}/external/v1/tracking/events`,
        postData,
        {
          'Content-Type': 'application/json'
        }
      );

      // Update last activity timestamp
      this.updateLastActivity();
    } catch(err) {
      console.log(err);
    }
  }

  isNewSession() {
    if (!this.lastActivity() || isNaN(this.lastActivity())) {
      // No last activity has been tracked, this is a new session
      return true;
    } else if (this.lastActivity() + this.sessionOverlapSeconds * 1000 < new Date() * 1) {
      // More than SESSION_OVERLAP_SECONDS seconds have passed since the last activity, count as new session
      return true;
    }

    return false;
  }

  lastActivity() {
    return parseInt(localStorage.getItem('baretracking-last-activity'));
  }

  updateLastActivity(ignoreUnlessSet = false) {
    if (ignoreUnlessSet && (!this.lastActivity() || isNaN(this.lastActivity()))) {
      console.log(`${ignoreUnlessSet} && ${this.lastActivity()} && ${!isNaN(this.lastActivity())}`)
      return;
    }

    localStorage.setItem('baretracking-last-activity', new Date() * 1);

    DEV_MODE && console.log(`Updating baretracking-last-activity ${ignoreUnlessSet} ${localStorage.getItem('baretracking-last-activity')}`);
  }

  setupEventListeners() {
    // Any click or tap should extend an open session
    window.addEventListener('click', () => this.updateLastActivity(true));
    window.addEventListener('touchstart', () => this.updateLastActivity(true));
    // Returning to an open tab should track a new session if applicable, otherwise extend the open session
    window.addEventListener('focus', () => {
      this.track('session');
      this.updateLastActivity(true)
    });
  }
}
